<template>
    <div>
        <el-dialog
            :append-to-body="true"
            :title="dlgTitle"
            width="90%"
            top="5vh"
            :visible="visible"
            @opened="onDialogOpened"
            @close="onDialogClosed"
        >
            <div class="table-search">
                <span class="span-style">{{ $t('filter') }}</span>
                <div class="search-row">
                    <el-radio-group
                        v-model="radioValue"
                        class="search-radio"
                        @change="onSelectClick"
                    >
                        <el-radio label="downloadNonHistoryRecords">{{ $t('FILE_NONE_DOWNLOAD') }}</el-radio>
                        <el-radio label="downloadSelfNone">{{ $t('FILE_SELF_NONE_DOWNLOAD') }}</el-radio>
                    </el-radio-group>
                    <div>
                        <el-date-picker
                            v-model="uploadDateRange"
                            type="daterange"
                            range-separator="~"
                            :start-placeholder="$t('file_upload_start_date')"
                            :end-placeholder="$t('file_upload_end_date')"
                            class="search-dateRange"
                            @change="onSelectClick"
                        >
                        </el-date-picker>
                    </div>
                    <div>
                        <el-select v-model="uploadBy" :placeholder="$t('UPLOAD_BY')" clearable class="search-uploadBy" @change="onSelectClick">
                            <el-option
                                v-for="(v, k) in fileArray
                                    .map((v) => v.uploadBy)
                                    .reduce((pre, v, k, arr) => {
                                        !pre.includes(v) ? pre.push(v) : ''
                                        return pre
                                    }, [])"
                                :key="k"
                                :label="v"
                                :value="v"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        <span style="margin-right: 5px">{{ $t('DOWNLOAD_SIZE') }}</span>
                        <el-select v-model="fileSizeUnit" style="width: 80px; margin-right: 10px" :placeholder="$t('UNIT')" @change="onSelectClick">
                            <el-option v-for="(v, k) in ['kB', 'MB', 'GB']" :key="k" :label="v" :value="v"></el-option>
                        </el-select>
                        <el-input-number
                            v-model="fileSize[0]"
                            :min="0"
                            style="width: 60px"
                            :controls="false"
                            placeholder=">0"
                            type="number"
                            @change="onSelectClick"
                        ></el-input-number>
                        ~
                        <el-input-number
                            v-model="fileSize[1]"
                            :min="0"
                            style="width: 60px"
                            :controls="false"
                            placeholder=">0"
                            type="number"
                            @change="onSelectClick"
                        ></el-input-number>
                    </div>
                    <div style="margin-left: 5px;">
                        <span style="margin-right: 5px;">{{$t('fileNameKeyword')}}</span>
                        <el-input v-model="fileName" style="width: 100px;" clearable @input="onInputName"></el-input>
                    </div>
                </div>
                <div class="search-btn">
                    <div style="margin-left: 20px; margin-right: 10px">
                        <el-button class="wl-green" @click="onReset">{{ $t('COMMON_CLEAR_BTN') }}</el-button>
                    </div>
                </div>
            </div>

            <el-table
                ref="multipleTable2"
                size="mini"
                height="50vh"
                border
                :data="paginationData"
                v-loading="tableLoading"
                :row-class-name="tableRowClassName"
                style="margin-top: 10px;"
            >
                <el-table-column width="80">
                    <template slot="header" slot-scope="scope">
                        <el-checkbox @change="handleAllSelectionChange()" :value="checkIsAllSelected"></el-checkbox>
                        ({{ multipleSelection.length }})
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox @change="handleSelectionChange(scope.row)" :value="checkIsSelected(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
                <template v-if="type === 'adminInvoice'">
                    <el-table-column prop="entityNameEn" width="200" :key="1" show-overflow-tooltip :label="$t('admin.entityNameEn')"></el-table-column>
                    <el-table-column prop="entityNameCn" width="200" :key="2" show-overflow-tooltip :label="$t('admin.entityNameCn')"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="entityName" show-overflow-tooltip :label="$t('TABLE_HEADER_entityList')" min-width="100"> </el-table-column>
                </template>
                <el-table-column prop="name" show-overflow-tooltip :label="fileNameColName" min-width="120">
                    <template
                      slot-scope="scope"
                    >
                      <span>
                        <svg-icon :icon-name="getUploadFileIcon(scope.row.name)" :size="20"></svg-icon>
                        {{scope.row.name}}
                      </span>
                    </template>
                </el-table-column>
                <template v-if="type === 'adminInvoice'">
                    <el-table-column prop="issuanceDate" width="130" :key="3" show-overflow-tooltip :label="$t('admin.issuanceDate')">
                        <template slot-scope="scope">
                            <span>{{ scope.row.issuanceDate | formatDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalAmount" width="140" :key="5" show-overflow-tooltip :label="$t('admin.totalAmount')" align="right" header-align="right">
                        <template slot-scope="scope">
                            {{ scope.row.totalAmount | formatNumThousandths }}
                        </template>
                    </el-table-column>
                    <el-table-column :key="12" prop="status" width="160"  :label="$t('admin.status')">
                        <template slot-scope="scope">
                            <div class="flex  item-center">
                            <svg-icon :icon-name='renderStatusIcon(scope.row.status)' :icon-color="renderStatusColor(scope.row.status)" :size="20" class="mr-10"></svg-icon>
                            <span :style="{color:renderStatusColor(scope.row.status)}">{{$t(`admin.${scope.row.status}`)}}</span>
                            </div>
                          </template>
                    </el-table-column>
                </template>
                <el-table-column prop="size" show-overflow-tooltip :label="$t('DOWNLOAD_SIZE')" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.size | fileSize }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="downloadDate" show-overflow-tooltip :label="$t('DOWNLOAD_TIME')"> </el-table-column>
                <el-table-column prop="downloadBy" show-overflow-tooltip :label="$t('DOWNLOAD_BY')"> </el-table-column>
                <el-table-column prop="uploadDate" show-overflow-tooltip :label="$t('UPLOAD_TIME')"> </el-table-column>
                <el-table-column prop="uploadBy" show-overflow-tooltip :label="$t('UPLOAD_BY')">
                    <template slot-scope="scope">
                        {{ scope.row.uploadBy ==='System synchronisation'?$t('admin.System synchronisation') : scope.row.uploadBy}}
                    </template>
                </el-table-column>
                <el-table-column prop="history" width="80" show-overflow-tooltip  :label="$t('HISTORY')" v-if="false">
                    <template slot-scope="scope">
                        <i
                            class="el-icon-document pointer"
                            v-if="scope.row.hasHistory && scope.row.hasHistory === 'YES'"
                            @click="queryFileHistory(scope.row)"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                  prop="action"
                  width="70"
                  v-if="false"
                  show-overflow-tooltip
                  
                  :label="$t('COMMON_DELETE')">
                    <template
                      slot-scope="scope"
                    >
                        <!-- 已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                        <i class="el-icon-delete delete" v-if="!noAuthority(scope.row)" @click="onDeleteClick(scope.row)"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="wl-pagination"
                :current-page="current"
                :total="total"
                :page-size="pageSize"
                :page-sizes="[10, 50, 100]"
                @size-change="onSizeChange"
                layout="prev, pager, next, sizes, total"
                @current-change="handleCurrentChange"
            >
            </el-pagination>

            <span slot="footer" class="dialog-footer">
                <span class="file-limit-tip" v-if="mode !== 'export'">{{ getSizeFormat }}</span>
                <el-button class="cancel-btn" @click="onDialogClosed">{{ $t('btn_cancel') }}</el-button>
                <el-button
                    :disabled="fileDownloading || multipleSelection.length === 0"
                    class="wl-green"
                    @click="handleOk"
                    >{{ $t('btn_confirm') }}</el-button
                >
            </span>
        </el-dialog>
        <!--        历史记录-->
        <file-history
            v-if="historyVisible"
            :tableData="historyData"
            :curUserName="curUserName"
            :downloadAble="downloadAble"
            :onCancel="toogleFileHistoryVisible"
            @on-file-download="(row) => onFileDownload(row)"
            @queryFileHistory="queryFileHistory"
        />
    </div>
</template>

<script>
import { formatFileSize } from '@/utils'
import API from '@/api'
import { mapGetters } from 'vuex'
import fileHistory from './file-history'
import windowConfig from '@/utils/windowConfig'
import SvgIcon from '@/components/svgIcon/index'
import { getFileIcon } from '../../components/data.js'

export default {
    name: 'FileConfirmModal',
    components: {
        fileHistory,
        SvgIcon
    },
    props: {
        groupList: Array,
        fileDownloading: Boolean,
        curUserName: String,
        downloadAble: Boolean,
        mode: String, //下载弹窗兼顾下载和导出，download 是下载，export 是导出
        type: String
    },
    data() {
        return {
            current: 1,
            pageSize: 10,
            multipleSelection: [],
            visible: false,
            configSize: windowConfig.download.size,
            tableLoading: false,
            historyVisible: false,
            loading: false,
            historyData: [],
            radioValue: '',
            uploadDateRange: [],
            uploadBy: '',
            fileSize: [],
            fileSizeUnitOptions: ['kB', 'MB', 'GB'],
            fileSizeUnit: 'kB',
            fileName: '',
            timer: '',
        }
    },
    computed: {
        total() {
            return this.fileArray.length
        },
        fileArray() {
            const fileArray = []
            this.groupList.forEach(
                ({ fileList, entityName,entityNameEn,entityNameCn,issuanceDate,totalAmount,status,category, id, messageList }) =>
                    fileList &&
                    fileList.forEach((file) => {
                        const fileData = {
                            entityName,
                            category,
                            id,
                            messageList,
                            ...file,
                            entityName,
                            entityNameEn,
                            entityNameCn,
                            issuanceDate,
                            totalAmount,
                            status
                        }
                        fileData.rowId = id
                        fileData.entityName = entityName||entityNameEn
                        if (
                            !(
                                this.getUser.userType === '2' &&
                                !this.downloadAble &&
                                file.uploadBy.indexOf('@') !== -1 &&
                                file.uploadBy.indexOf(this.curUserName) == -1
                            )
                        ) {
                            fileArray.push(fileData)
                        }
                    })
            )
            fileArray.sort(function (a, b) {
                return a.uploadDate < b.uploadDate ? 1 : -1
            })
            return fileArray
        },
        getSizeFormat() {
            const [originalSize, hasUnknownFileSize] = this.getSize
            const size = formatFileSize(originalSize) || '0B'
            if (hasUnknownFileSize) return `${this.$t('FILE_TOTAL_SIZE_HINT', { size })}`
            return `${this.$t('FILE_SELECTED_SIZE_HINT', { size })}`
        },
        getSize() {
            let size = 0
            let hasUnknownFileSize = false
            this.multipleSelection.forEach((file) => {
                if (!file.size) hasUnknownFileSize = true
                size += parseInt(file.size || 0)
            })
            return [size, hasUnknownFileSize]
        },
        paginationData() {
            const { fileArray, current, pageSize } = this
            const res = fileArray.slice((current - 1) * pageSize, current * pageSize)
            return res
        },
        selectedDataMap() {
            const res = {}
            this.multipleSelection.forEach((file) => {
                res[file.fileId + file.name] = file
            })
            return res
        },
        checkIsAllSelected() {
            return !this.paginationData.some((item) => this.selectedDataMap[item.fileId + item.name] === undefined)
        },
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        }),
        dlgTitle(){
            return this.type === 'adminInvoice'? `${this.$t('FILE_LIST_TITLE')} (${this.$t('admin.feeNote')})`:this.$t('FILE_LIST_TITLE')
        },
        fileNameColName(){
            return this.type === 'adminInvoice'? `${this.$t('DOWNLOAD_FILE_NAME')} (${this.$t('admin.feeNote')})`:this.$t('DOWNLOAD_FILE_NAME') 
        }
    },
    methods: {
        getUploadFileIcon(filename) {
            return getFileIcon(filename);
        },
        renderStatusIcon(status) {
            return `status_${status}`
        },
        renderStatusColor(status) {
            const statusColorOptions = {
                'FULLY PAID':'#00c0ae',
                'NOT PAID':'#fd349c',
                'PARTIALLY PAID':'#1e49e2',
                'CANCELLED':'#7213ea',
            }
            return statusColorOptions[status]
        },
        noAuthority(file) {
            return file.uploadBy && file.uploadBy.indexOf('@') === -1 && this.getUser.userType === '2' ||
              file.uploadBy && file.uploadBy.indexOf('@') !== -1 && this.getUser.userType === '1'
        },
        onDeleteClick(row) {
            const params = {
                fileId: row.fileId,
                id: row.groupEntityTopicId,
                fileNameList: [row.name],
                source: 'exchange',
                ifDeleteHistory: true,
                siteId: this.getSite.siteId
            }
            this.$confirm(this.$t('FILE_DELETE_WARNING_MSG'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
            }).then(() => {
                // 删除----
                API.clientAdmin.deleteUploadFiles(params).then((res) => {
                    if (res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.groupList.map(groupItem => {
                            if(row.rowId === groupItem.id) {
                                groupItem.fileList.splice(groupItem.fileList.findIndex(v => v.fileId === row.fileId), 1)
                            }
                        })
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            })
        },
      /**
         * 勾选 被点击
         */
        async onSelectClick() {
            this.tableLoading = true
            this.multipleSelection = [...this.fileArray]
            const func = ({
                downloadNonHistoryRecords: this.downloadNonHistoryRecords,
                selectAll: this.selectAll,
                inverse: this.inverse,
                downloadSelfNone: this.downloadSelfNone
            }[this.radioValue])
            if (func != '' && typeof func == 'function') {
                await func()
            }
            this.selectFileStep2()
            setTimeout(() => {
              this.tableLoading = false;
            }, 500);
        },
        onReset() {
            this.radioValue = '';
            this.uploadDateRange = [];
            this.uploadBy = '';
            this.fileSizeUnit = 'kB';
            this.fileSize = [];
            this.fileName = '';
            this.handleAllSelectionChange();
        },
        onInputName() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                if(this.fileName !== ''){
                    this.onSelectClick();
                }
            }, 500)
        },
        selectFileStep2() {
            if (this.uploadDateRange != null && this.uploadDateRange.length == 2) {
                // 按上传时间勾选
                this.multipleSelection = this.multipleSelection.filter(v => {
                    if (!v.uploadDate || v.uploadDate == null) return false
                    const timestamp = Date.parse(v.uploadDate)
                    const d1 = new Date(this.uploadDateRange[0])
                    const d2 = new Date(this.uploadDateRange[1])
                    return timestamp >= Date.parse(`${d1.getFullYear()}-${d1.getMonth() - 0 + 1}-${d1.getDate()} 00:00:00`) && timestamp <= Date.parse(`${d2.getFullYear()}-${d2.getMonth() - 0 + 1}-${d2.getDate()} 23:59:59`)
                })
            }
            if (this.uploadBy != '') {
                // 按上传人勾选
                this.multipleSelection = this.multipleSelection.filter(v => v.uploadBy == this.uploadBy)
            }
            // 按文件大小勾选
            const unitWith1024 = Math.pow(1024, this.fileSizeUnitOptions.indexOf(this.fileSizeUnit) + 1)
            if(this.fileSize[0]) {
                if(this.fileSize[0] < 0) {
                    return false
                } else {
                    this.multipleSelection = this.multipleSelection.filter(v => {
                        return v.size >= this.fileSize[0] * unitWith1024
                    })
                }
            }
            if(this.fileSize[1]) {
                if(this.fileSize[1] < 0 || this.fileSize[0] && this.fileSize[1] < this.fileSize[0]) {
                    return false
                } else {
                    this.multipleSelection = this.multipleSelection.filter(v => {
                        return v.size <= this.fileSize[1] * unitWith1024
                    })
                }
            }
            if (this.fileName != '') {
                // 按文件名勾选
                this.multipleSelection = this.multipleSelection.filter(v => v.name.toLowerCase().indexOf(this.fileName.toLowerCase()) !== -1)
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.uploadBy && row.uploadBy.indexOf('@') === -1) {
                return 'kp-update-row'
            }
            return ''
        },
        onDialogClosed() {
            this.radioValue = ''
            this.uploadDateRange = []
            this.uploadBy = ''
            this.fileSize = []
            this.fileSizeUnit = 'kB'
            this.fileName = ''
            this.visible = false
        },
        onDialogOpened() {
            this.multipleSelection = [...this.fileArray]
            this.current = 1
            this.pageSize = 10
        },
        handleOk() {
            const [size] = this.getSize; 
            if (this.mode !== 'export' && size > windowConfig.download.size) {
                this.$confirm(
                    this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                    this.$t('largeSizeFileAlertTitle'),
                    {
                        distinguishCancelAndClose: true,
                        showConfirmButton:false,
                        cancelButtonText: this.$t('btn_ok'),
                        cancelButtonClass: 'wl-green',
                    }
                ).then(() => {})
            } else {
                this.$emit('ok', this.multipleSelection)
            }
        },
        handleSelectionChange(val) {
            const index = this.multipleSelection.findIndex((item) => item.fileId === val.fileId && item.name === val.name)
            if (index !== -1) {
                this.multipleSelection.splice(index, 1)
            } else {
                this.multipleSelection.push(val)
            }
        },
        onSizeChange(size) {
            this.current = 1
            this.pageSize = size
        },
        handleCurrentChange(val) {
            this.current = val
        },
        checkIsSelected(val) {
            return this.multipleSelection.findIndex((item) => item.fileId === val.fileId && item.name === val.name) !== -1
        },
        handleAllSelectionChange() {
            if (this.checkIsAllSelected) {
                this.paginationData.forEach((item) => {
                    this.handleSelectionChange(item)
                })
            } else {
                this.paginationData.forEach((item) => {
                    if (!this.selectedDataMap[item.fileId + item.name]) {
                        this.handleSelectionChange(item)
                    }
                })
            }
        },
        downloadNonHistoryRecords() {
            this.multipleSelection = []
            this.multipleSelection.push(...this.fileArray.filter((file) => !file.downloadBy))
            // this.selectFileStep2()
        },
        selectAll() {
            this.fileArray.forEach((item) => {
                if (!this.selectedDataMap[item.fileId + item.name]) {
                    this.handleSelectionChange(item)
                }
            })
            // this.selectFileStep2()
        },
        inverse() {
            this.fileArray.forEach((item) => {
                this.handleSelectionChange(item)
            })
            // this.selectFileStep2()
        },
        // 用户未下载
        async downloadSelfNone() {
            const { code, data } = await API.pbc.queryNoDownLoad({
                fileList: this.fileArray,
                manipulator: this.getUser.userId,
                siteId: this.getSite.siteId
            })
            if (code == '1') {
                this.multipleSelection = data
            } else {
                this.$message.error(this.$t(code))
            }
        },
        clearHistoryFlag(name, rowId) {
            this.groupList.map(groupItem => {
                if(groupItem.id === rowId) {
                    groupItem.fileList.map(fileItem => {
                        if(fileItem.name === name) {
                            fileItem.hasHistory = null
                        }
                    })
                }
            })
        },
        async queryFileHistory(row) {
            try {
                this.historyVisible = true
                this.loading = true
                const { data, code } = await API.pbc.queryFileHistory({
                    fileName: row.name,
                    groupEntityTopicId: row.groupEntityTopicId,
                    siteId: this.getSite.siteId,
                    source: 'exchange'
                })
                if (code === '1') {
                    if (data.length > 0) data.shift()
                    if(data.length === 0) {
                        this.clearHistoryFlag(row.name, row.groupEntityTopicId)
                    }
                    this.historyData = data.map(v => {
                        v.groupEntityTopicId = row.groupEntityTopicId
                        return v
                    })
                    this.selectFileStep2()
                } else {
                    this.$message.error(this.$t(code))
                }
                this.loading = false
            }
            catch(err) {}
            finally {}
        },
        toogleFileHistoryVisible() {
            this.historyVisible = !this.historyVisible
        },
        onFileDownload(row) {
            this.$emit('on-file-download', [{ fileId: row.fileId, id: row.groupEntityTopicId, name: row.name }])
        }
    }
}
</script>

<style scoped>
::v-deep .el-dialog__body{
    padding: 15px;
}
.dialog-footer > * {
    margin: 0 5px;
}
.pointer{
    cursor: pointer;
    color: #409EFF;
}
.el-icon-download {
    color: #409EFF;
}
.delete {
    color: #fd349c;
    cursor: pointer;
}
::v-deep .el-table tr:hover {
    color: #636363;
}
.search-row{
    display: flex;
    align-items: center;
    margin-left: 10px;
    align-items: center;
}
.search-btn{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
}
.span-style{
    display: flex;
    font-weight: 700;
    font-size: 12px;
    vertical-align: middle;
    margin-left: 10px;
    align-items: center;
}
.table-search {
    display: flex;
    justify-content:
    flex-start;
    background: #F3F6FF;
    height: 40px;
    border-radius: 5px;
}
.search-radio{
    display: flex;
    align-items: center;
    margin-right: 10px
}
.search-radio ::v-deep .el-radio{
    margin-right: 5px;
}
.search-dateRange{
    width: 240px !important;
    margin-right: 10px;
}
::v-deep .search-dateRange .el-range-input{
    font-size: 12PX;
}
.search-uploadBy{
    margin-right: 10px;
    width: 150px;
}
::v-deep .el-radio__inner,
::v-deep .el-input__inner
{
    border-color: #409EFF;
}
::v-deep .kp-update-row {
   background: #0091da;
   color: #ffffff;
}
::v-deep .kp-update-row .pointer {
      color: #fff;
    }
::v-deep .kp-update-row:hover .pointer {
      color: #3879eb;
    }
::v-deep .el-table tr:hover {
    color: #636363;
}
::v-deep .el-date-editor .el-range__icon,
::v-deep .el-select .el-input .el-select__caret
{
    color: #409EFF
}
::v-deep .search-dateRange .el-range-input {
    color: #409EFF;
}
::v-deep .el-input--small .el-input__inner {
    color: #409EFF;
}
</style>
